import React from "react";
import styles from "../../styles/_containers/_automations/automationCard.module.scss";

const CONDITION_LABELS = {
  days: "ימים",
  hours: "שעות",
  uses: "שימושים",
  cancellations: "ביטולים",
  bookings: "הזמנות",
};

const TRIGGER_LABELS = {
  appointment_completed: "אחרי שהתור הסתיים",
  customer_inactive: "לקוח לא חזר",
  subscription_expiring: "לפני תפוגת מנוי",
  punch_card_low: "כרטסייה מסתיימת",
  birthday: "יום הולדת",
  customer_created: "לקוח חדש נרשם",
  no_show: "אי-הגעה",
  appointment_cancelled: "תור בוטל",
  low_bookings: "יום חלש ביומן",
  serial_canceller: "מבטל סדרתי",
  review_positive: "ביקורת חיובית",
  review_negative: "ביקורת שלילית",
};

const BoltIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m13.5 2-8 11h6L10.5 22l8-12h-6l1-8Z" /></svg>
);

const MessageIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5.5h14v10H9l-4 3v-13Z" /></svg>
);

const BellIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 9a6 6 0 0 0-12 0c0 7-3 7-3 8h18c0-1-3-1-3-8ZM10 21h4" /></svg>
);

const TagIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m4 4 7 .2 8.8 8.8-6.8 6.8L4.2 11 4 4Z"/><circle cx="8" cy="8" r="1.2" /></svg>
);

const EditIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m4 16-.8 4.8L8 20l11-11-4-4L4 16Z"/><path d="m13.5 6.5 4 4" /></svg>
);

const TrashIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3m3 0-1 14H7L6 7m4 4v6m4-6v6" /></svg>
);

export default function AutomationCard({ automation, onToggle, onEdit, onDelete }) {
  const msgAction = automation.actions?.find(action => action.type === "send_message");
  const channel = msgAction?.channel;
  const hasNotify = automation.actions?.some(action => action.type === "notify_business");
  const hasTag = automation.actions?.some(action => action.type === "tag_customer");
  const triggerLabel = TRIGGER_LABELS[automation.triggerType] || "פעולה אוטומטית";

  const conditionText = automation.conditionValue
    ? `${automation.conditionValue} ${CONDITION_LABELS[automation.conditionUnit] || automation.conditionUnit}`
    : null;

  const delayText = automation.delay
    ? automation.delay >= 60
      ? `${Math.round(automation.delay / 60)} שעות השהיה`
      : `${automation.delay} דקות השהיה`
    : null;

  return (
    <article className={`${styles.card} ${!automation.isActive ? styles.cardInactive : ""}`}>
      <div className={styles.cardHeader}>
        <div className={styles.cardIdentity}>
          <div className={styles.iconWrap}><BoltIcon /></div>
          <div className={styles.titleGroup}>
            <div className={styles.statusLine}>
              <span className={`${styles.statusDot} ${automation.isActive ? styles.statusDotActive : styles.statusDotInactive}`} />
              <span>{automation.isActive ? "פעילה" : "מושהית"}</span>
            </div>
            <h3 className={styles.title}>{automation.name}</h3>
            <p className={styles.description}>{automation.description || triggerLabel}</p>
          </div>
        </div>
        <label className={styles.toggle} title={automation.isActive ? "השהיית האוטומציה" : "הפעלת האוטומציה"}>
          <input
            className={styles.toggleInput}
            type="checkbox"
            checked={automation.isActive}
            onChange={() => onToggle(automation._id)}
            aria-label={`${automation.isActive ? "השהה" : "הפעל"} את ${automation.name}`}
          />
          <span className={styles.toggleSlider} />
        </label>
      </div>

      <div className={styles.badges}>
        {channel && (
          <span className={`${styles.badge} ${channel === "whatsapp" ? styles.whatsappBadge : styles.smsBadge}`}>
            <MessageIcon /> {channel === "whatsapp" ? "WhatsApp" : "SMS"}
          </span>
        )}
        {hasNotify && <span className={`${styles.badge} ${styles.notifyBadge}`}><BellIcon /> התראה לעסק</span>}
        {hasTag && <span className={`${styles.badge} ${styles.tagBadge}`}><TagIcon /> תיוג לקוח</span>}
        {conditionText && <span className={styles.metaBadge}>{conditionText}</span>}
        {delayText && <span className={styles.metaBadge}>{delayText}</span>}
      </div>

      {msgAction?.content ? (
        <div className={styles.preview}>
          <div className={styles.previewHeader}><MessageIcon /><span>הודעה שתישלח</span></div>
          <p className={styles.previewText}>{msgAction.content}</p>
        </div>
      ) : (
        <div className={styles.internalAction}>
          <BellIcon />
          <span>האוטומציה מבצעת פעולה פנימית בעסק</span>
        </div>
      )}

      <div className={styles.actions}>
        <button className={styles.editBtn} onClick={() => onEdit(automation)} type="button">
          <EditIcon /> עריכת האוטומציה
        </button>
        <button className={styles.deleteBtn} onClick={() => onDelete(automation._id)} type="button" aria-label={`מחיקת ${automation.name}`}>
          <TrashIcon /><span>מחיקה</span>
        </button>
      </div>
    </article>
  );
}
